<template>
  <div class="online-order">
    <div class="header">
      <img class="bg" src="@/assets/dingcan.jpg" alt="bg" />
    </div>
    <div class="tip-meal-row">
      <span class="tip">
        <span class="circle-icon">○</span>
        今日可就餐
      </span>
      <span class="meal-label">早餐、午餐、晚餐</span>
    </div>
  
    <div class="row date-row">
      <label class="date-label">
        <span class="circle-icon">○</span>
        就餐日期
      </label>
      <el-date-picker
        v-model="date"
        type="date"
        placeholder="请选择"
        @change="handleDateChange"
      ></el-date-picker>
    </div>
  
    <div class="row">
      <label>
        <span class="circle-icon">○</span>
        就餐时间
      </label>
      <div class="time-box">
        <button
          v-for="t in ['早餐', '午餐', '晚餐']"
          :key="t"
          :class="['time-btn', { active: time === t }]"
          @click="time = t; checkDate()"
        >
          {{ t }}
        </button>
      </div>
    </div>
    <div v-if="menu">
      <h4>就餐菜品：{{ menu }}</h4>
    </div>
    <button class="submit-btn" @click="submitOrder">提交</button>
  
    <div class="rules">
      <h3>规则：</h3>
      <pre class="rules-content">{{ rules }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: this.formatDate(new Date()), // 使用 formatDate 方法格式化日期
      time: '午餐',
      remark: '',
      rules: '', // 添加 rules 属性
      weekDay: null, // 添加 weekDay 属性
      menu: [] // 添加 menu 属性
    };
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    handleDateChange(value) {
      // 当日期选择器的值改变时，更新 date 和 weekDay
      if (value) {
      this.date = this.formatDate(value);
      this.weekDay = value.getDay(); // 获取星期几（0-6，0为星期天，6为星期六）
    } else {
      this.date = this.formatDate(new Date()); // 设置为当天日期
      this.weekDay = new Date().getDay(); // 获取当天是星期几（0-6，0为星期天，6为星期六）
    }
      this.fetchMenu();
    },
    checkDate() {
      if (!this.date) {
        this.date = this.formatDate(new Date());
      }
    },
    async fetchMenu() {
      try {
        const response = await this.$axios.post(`/api/get_caidan`,{
          week:this.weekDay || new Date().getDay() ,
          leixing:this.time
        });
        console.log(this.weekDay,this.time)
        const data = response.data;
        console.log(data)
        if (data.code === 0) {
          this.menu = data.data; // 假设 API 返回的数据结构是 { code: 0, data: ['菜单内容'] }
        } else {
          console.error('Failed to fetch menu:', data.message);
        }
      } catch (error) {
        console.error('Error fetching menu:', error);
      }

    },
    async submitOrder() {
      const orderData = {
        jiucanTime: this.date,
        leixing: this.time
      };
  
      try {
        const response = await this.$axios.post('/api/tijiao_dingdan', orderData);
        const data = response.data;
        if (data.code === 0) {
          this.$message.success({
            message: '报餐成功！',
            type: 'success',
            duration: 2000 // 提示显示的时长，单位为毫秒
          });
        } else {
          this.$message.error({
            message: '报餐失败: ' + data.message,
            duration: 2000
          });
        }
      } catch (error) {
        console.error('Error submitting order:', error);
        this.$message.error({
        message: '报餐失败: 网络错误',
        duration: 2000
      });
      }
    },
    async fetchRules() {
      try {
        const token1 = localStorage.getItem('token');
        console.log('token--------------baocan', token1);
        const response = await this.$axios.get('/api/show_baocan_setting');
        const data = response.data;
         console.log(data)
        if (data.code === 0) {
          this.rules = data.data.explain; // 假设 API 返回的数据结构是 { code: 1, data: '规则内容' }
        } else {
          console.error('Failed to fetch rules:', data.message);
          this.rules = '规则加载失败，请稍后再试。';
        }
      } catch (error) {
        console.error('Error fetching rules:', error);
        this.rules = '规则加载失败，请稍后再试。';
      }
    }
  },
  watch: {
    time: 'fetchMenu' // 当 time 改变时，调用 fetchMenu 方法
  },
  mounted() {
    this.fetchRules();
  }
};
</script>

<style scoped>
/* 容器 */
.online-order {
  width: 100%;
  min-height: 100vh;
  background: #f5f7fa;
  font-size: 16px;
  color: #333;
  padding-bottom: 20px;
}

/* 顶部黄色背景图片 + 标题 */
.header {
  position: relative;
  height: 120px;
  text-align: center;
  overflow: hidden;
}
.header .bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.header h1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  color: #fff;
  font-size: 22px;
  font-weight: 600;
}
.tip-meal-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

/* 圆圈样式 */
.circle-icon {
  color: #ff9800;
  font-weight: bold;
  margin-right: 4px;
}

/* 今日可就餐 */
.tip {
  text-align: center;
  font-weight: 600;
  margin: 12px 0;
  font-size: 15px;
}

/* 午餐文字 */
.meal-label {
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: #ff9800;
}

/* 行样式 */
.row {
  margin-right: 20px;
}
.row label {
  display: block;
  font-weight: 600;
  margin: 12px 0;
  font-size: 15px;
}
.row input[type="date"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 15px;
}

/* 时间按钮 */
.time-box {
  display: flex;
  justify-content: space-between;
}
.time-btn {
  flex: 1;
  margin: 0 4px;
  padding: 14px 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  font-size: 15px;
  transition: all 0.2s;
}
.time-btn.active {
  border-color: #ff9800;
  background: #ff9800;
  color: #fff;
}

/* 提交按钮 */
.submit-btn {
  display: block;
  width: calc(100% - 32px);
  margin: 0 16px;
  padding: 10px 0;
  border: none;
  border-radius: 8px;
  background: #ff9800;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
}

/* 左右分布：标签左，输入框右 */
.date-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.date-label {
  margin: 0; /* 去掉 label 默认的 margin */
  white-space: nowrap;
}

.date-input {
  flex: 1; /* 占满剩余宽度 */
  margin-left: 12px; /* 与标签间距 */
}

.rules {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.rules h3 {
  margin-top: 0;
  font-size: 18px;
  color: #333;
}

.rules p {
  margin: 8px 0;
  font-size: 14px;
  color: #666;
}
.rules pre.rules-content {
  white-space: pre-wrap; /* 保留换行符并自动换行 */
  font-family: inherit; /* 使用默认字体 */
  margin: 0; /* 去掉 pre 默认的 margin */
}
</style>